<button
  data-testid="logoutFromAllDevicesBtn"
  sdButton
  type="outlined-gray"
  radius="l"
  [fullWidth]="true"
  size="m"
  (click)="logout()"
>
  Выйти со всех устройств
</button>
